// eslint-disable-next-line import/prefer-default-export
export var breakpointValue = "medium";